import BaseModel from '../../base/BaseModel.model';
import UserResearchCenter from '@/models/security/userResearchCenter.Model';
import { InstitutionType } from '@/enums/InstitutionType';
import Faculty from '@/models/faculty.model';

export default class ResearchCenter extends BaseModel {

    public name?:string;
    public userId?:number;
    public abbreviation?:string;
    public email?:string;
    public provinceId?:number;
    public municipalityId?:number;
    public provinceName?:string;
    public municipalityName?:string;
    public institutionId?:number;
    public image:any = [];
    public file:any = null;
    public centerName?:string;
    public userAdminId?: number;
    public adminCenter?: string;
    public institutionType?: InstitutionType | null;

    public userResearchCenter?: UserResearchCenter | null = new UserResearchCenter();
    public faculties: Array<Faculty> = [];

    constructor(){
        super();
        this.init();
    }

    init(){
        this.name = '',
        this.abbreviation = '',
        this.email = '',
        this.provinceId = undefined;
        this.municipalityId = undefined;
        this.provinceName = '';
        this.userId = undefined;
        this.municipalityName = '';
        this.institutionId =  undefined;
        this.image = [];
        this.file = null;
        this.centerName = "";
        this.institutionType = null;
        this.userAdminId = undefined;
        this.adminCenter = '';
        this.userResearchCenter = new UserResearchCenter();
    }
}